import { createContext } from 'react';

const kitContext = createContext();

export default kitContext;